export const getStudentTableColumns = () => [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => text || `S${(index + 1).toString().padStart(3, '0')}`,
    },
    {
      title: "Name",
      key: "name",
      render: (record) => (
        record.full_name ||
        record.name ||
        `${record.firstName || ""} ${record.lastName || ""}`.trim() ||
        "N/A"
      ),
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
      render: (text, record) => {
        if (text) return text;
        if (record.grade) return `Grade ${record.grade}`;
        if (record.className) return record.className;
        return "N/A";
      },
    },
  ];